import {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator, CCText,
    Modal,
    View
} from '../../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {
    BorderlessButton,
    ThemeButton
} from '../../../../custom-packages/react-button-package/ButtonPackage';

import AppConfig from '../../../../AppConfig';

import {useParams} from "react-router-dom";
import {LightenColor} from "../../../../ColorFunctions";
import MenuPreview from "../../../../components/admin/Menu/MenuPreview";
import Styles from "../../../../Styles";
import MenuEditorTopBar from "./Components/MenuEditorTopBar";
import ChocoFormTS from '../../../../custom-packages/react-chocoforms/typescript/ChocoFormTS';
import ChocoForm from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoControl from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";
import Menu from "../../../../models/menu/Menu";
import {GetAuthObject} from "../../../../authentication/AuthFunctions";
import MenuEditorBottomBar from "./Components/MenuEditorBottomBar";

export const TMenuCustomizerScreen = {
    // English
    "enUS": {
        'CUSTOMIZE': 'Customize',
        'CUSTOMIZE_DESC': 'Change the appearance of your menu',
        'CARD_STYLES': 'Food Styles',
        'MENU_NAME': 'Menu Name',
        'PRIMARY_COLOR': 'Main Color',
        'BACKGROUND_COLOR': 'Background Color',
        'FONT_FAMILY': 'Font Family',
        'SAVE': 'Save',
        'OPACITY': 'Opacity',
        'BORDER_RADIUS': 'Corner Softness',
        'BORDER_WIDTH': 'Border Width',
        'BORDER_COLOR': 'Border Color',
        'SHADOW_INTENSITY': 'Shadow Intensity',
        'PREVIEW': 'Preview',
        'AVAILABLE_BASIC': 'Available with the Basic Plan',
        'TEXT_ALIGN': 'Text Alignment',
        'LEFT': 'Left',
        'CENTER': 'Center',
        'RIGHT': 'Right',

        'EDITOR': 'Editor',

        'TO_MENU': 'Go To Menu',
        'QR_CODE': 'QR Code',

        //FOR PREVIEW
        'PREVIEW_DESC': 'See how your menu will look and save your changes',
        'PREVIEW_SECTION': 'Category',
        'PREVIEW_FOOD': 'Food',
        'PREVIEW_DESCRIPTION': 'Velit necessitatibus et voluptatem culpa. Eos sit voluptas laudantium qui odio blanditiis accusantium. Quia culpa quos soluta cupiditate.',
    },
    // Spanish
    "esMX": {
        'CUSTOMIZE': 'Apariencia',
        'CUSTOMIZE_DESC': 'Cambia la apariencia de tu Menú',
        'CARD_STYLES': 'Estilos del Alimento',
        'MENU_NAME': 'Nombre del Menú',
        'PRIMARY_COLOR': 'Color Principal',
        'BACKGROUND_COLOR': 'Color de Fondo',
        'FONT_FAMILY': 'Fuente de Letra',
        'SAVE': 'Guardar',
        'OPACITY': 'Opacidad',
        'BORDER_RADIUS': 'Suavizado de Esquinas',
        'BORDER_WIDTH': 'Ancho de Bordes',
        'BORDER_COLOR': 'Color de Bordes',
        'SHADOW_INTENSITY': 'Intensidad de Sombras',
        'PREVIEW': 'Ver y Guardar',
        'AVAILABLE_BASIC': 'Disponible con el Plan Básico',
        'TEXT_ALIGN': 'Alineamiento',
        'LEFT': 'Izquierda',
        'CENTER': 'Centrar',
        'RIGHT': 'Derecha',

        'EDITOR': 'Editor',

        'TO_MENU': 'Ir Al Menú',
        'QR_CODE': 'Código QR',

        //FOR PREVIEW
        'PREVIEW_DESC': 'Vee como se verá tu menú y guarda tus cambios',
        'PREVIEW_SECTION': 'Categoría',
        'PREVIEW_FOOD': 'Alimento',
        'PREVIEW_DESCRIPTION': 'Velit necessitatibus et voluptatem culpa. Eos sit voluptas laudantium qui odio blanditiis accusantium. Quia culpa quos soluta cupiditate.',
    }
}


const MenuCustomizerScreen = (props) => {
    const auth = GetAuthObject()

    const params = useParams()
    const id = params.id;

    const [needsPreview, setNeedsPreview] = useState(false);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [saving, setSaving] = useState(false);
    const [menu, setMenu] = useState<Menu | null>(null);
    const [styleForm, setStyleForm] = useState<ChocoForm>(new ChocoForm({
        men_primary_color: new ChocoControl({
            elementType: 'color',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].PRIMARY_COLOR,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].PRIMARY_COLOR + '*',
            value: '',
            className: 'col-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        men_background_color: new ChocoControl({
            elementType: 'color',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR + '*',
            value: '',
            className: 'col-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        men_font_family: new ChocoControl({
            elementType: 'select',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].FONT_FAMILY,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].FONT_FAMILY + '*',
            value: 'Roboto',
            className: 'col-6',
            valuesAreFonts: true,
            options: [{
                value: 'Aclonica',
                label: 'Aclonica'
            }, {
                value: 'ADLaMDisplay',
                label: 'ADLaMDisplay'
            }, {
                value: 'Arial',
                label: 'Arial'
            }, {
                value: 'ConcertOne',
                label: 'ConcertOne'
            }, {
                value: 'Courier New',
                label: 'Courier New'
            }, {
                value: 'Electrolize',
                label: 'Electrolize'
            }, {
                value: 'Georgia',
                label: 'Georgia'
            }, {
                value: 'Helvetica',
                label: 'Helvetica'
            }, {
                value: 'Lobster',
                label: 'Lobster'
            }, {
                value: 'Palatino',
                label: 'Palatino'
            }, {
                value: 'PermanentMarker',
                label: 'Permanent Marker'
            }, {
                value: 'PressStart2P',
                label: 'Press Start 2P'
            }, {
                value: 'Righteous',
                label: 'Righteous'
            }, {
                value: 'Roboto',
                label: 'Roboto'
            }, {
                value: 'SpecialElite',
                label: 'Special Elite'
            }, {
                value: 'Tahoma',
                label: 'Tahoma'
            }, {
                value: 'Times',
                label: 'Times'
            }, {
                value: 'Times New Roman',
                label: 'Times New Roman'
            }, {
                value: 'Verdana',
                label: 'Verdana'
            },],
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        men_text_align: new ChocoControl({
            elementType: 'select',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].TEXT_ALIGN,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].TEXT_ALIGN + '*',
            value: 'left',
            className: 'col-6',
            options: [{
                value: 'left',
                label: TMenuCustomizerScreen[AppConfig.lang].LEFT
            }, {
                value: 'center',
                label: TMenuCustomizerScreen[AppConfig.lang].CENTER
            }, {
                value: 'right',
                label: TMenuCustomizerScreen[AppConfig.lang].RIGHT
            }],
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
    }));
    const [cardForm, setCardForm] = useState<ChocoForm>(new ChocoForm({
        men_card_background_color: new ChocoControl({
            elementType: 'color',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR + '*',
            value: '',
            className: 'col-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        men_card_border_color: new ChocoControl({
            elementType: 'color',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_COLOR,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].BORDER_COLOR + '*',
            value: '',
            className: 'col-6',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
        men_card_border_width: new ChocoControl({
            elementType: 'slider',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_WIDTH,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].BORDER_WIDTH + '*',
            value: 1,
            step: 1,
            errorMessage: '',
            validation: new ChocoValidation({
                required: true,
                min: 0,
                max: 10
            }),
        }),
        men_card_border_radius: new ChocoControl({
            elementType: 'slider',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_RADIUS,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].BORDER_RADIUS + '*',
            value: 5,
            step: 5,
            errorMessage: '',
            validation: new ChocoValidation({
                required: true,
                min: 0,
                max: 40
            }),
        }),
        men_card_opacity: new ChocoControl({
            elementType: 'slider',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].OPACITY,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].OPACITY + '*',
            value: .5,
            step: .1,
            errorMessage: '',
            validation: new ChocoValidation({
                required: true,
                min: 0,
                max: 1
            }),
        }),
        men_card_shadow_intensity: new ChocoControl({
            elementType: 'slider',
            elementConfig: {
                placeholder: TMenuCustomizerScreen[AppConfig.lang].SHADOW_INTENSITY,
            },
            label: TMenuCustomizerScreen[AppConfig.lang].SHADOW_INTENSITY + '*',
            value: 1,
            step: 1,
            errorMessage: '',
            validation: new ChocoValidation({
                required: true,
                min: 0,
                max: 5
            }),
        }),
    }));

    const editMenu = async () => {
        const styleControls = {...styleForm.controls};
        const cardControls = {...cardForm.controls};

        if (
            (styleForm.edited && styleForm.isValidForm)
            ||
            (cardForm.edited && cardForm.isValidForm)
        ) {
            setSaving(true)
            setSaveButtonDisabled(true)

            let formData = {};

            formData['men_id'] = id;

            for (let key in styleControls) {
                formData[key] = styleControls[key].value;
            }

            for (let key in cardControls) {
                formData[key] = cardControls[key].value;
            }

            const response = await fetch(AppConfig.URL + '/Menu/Create/' + id, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                //const eventData = data.menu;
            }

            setSaving(false)
        } else {

        }
    }

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchMenu/" + id, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            var json = await response.json();

            const styleControls = {...styleForm.controls}
            const cardControls = {...cardForm.controls}

            styleControls["men_primary_color"].value = json.menu.men_primary_color;
            styleControls["men_background_color"].value = json.menu.men_background_color;
            styleControls["men_font_family"].value = json.menu.men_font_family;
            styleControls["men_text_align"].value = json.menu.men_text_align;

            cardControls["men_card_background_color"].value = json.menu.men_card_background_color;
            cardControls["men_card_border_color"].value = json.menu.men_card_border_color;
            cardControls["men_card_opacity"].value = json.menu.men_card_opacity;
            cardControls["men_card_border_radius"].value = json.menu.men_card_border_radius;
            cardControls["men_card_border_width"].value = json.menu.men_card_border_width;
            cardControls["men_card_shadow_intensity"].value = json.menu.men_card_shadow_intensity;

            setMenu(json.menu);
            setStyleForm(new ChocoForm(styleControls));
            setCardForm(new ChocoForm(cardControls));

            setLoading(false);
        };

        f();
    }, [id]);

    if (loading)
        return <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
            <MenuEditorTopBar
                menuID={id}
            />
            <MenuEditorBottomBar
                menuID={id}
            />
            <View style={{height: 70}}></View>
            <ActivityIndicator style={{marginTop: 170}}/>
        </View>

    return <View>
        <MenuEditorTopBar
            menuID={id}
        />
        <MenuEditorBottomBar
            menuID={id}
        />
        <View style={{height: 70}}></View>
        <View>
            <View>
                <CCText>
                    <h1
                        style={{marginBottom: 0}}
                    >
                        {TMenuCustomizerScreen[AppConfig.lang].CUSTOMIZE}
                    </h1>
                </CCText>
                <CCText
                    style={{
                        color: '#666666',
                        fontStyle: 'italic',
                        fontSize: '1.15rem'
                    }}
                >
                    {TMenuCustomizerScreen[AppConfig.lang].CUSTOMIZE_DESC}
                </CCText>
            </View>
            <View
                style={{
                    marginTop: 15
                }}
                className={'row'}
            >
                <View className={'col-md-6'}>
                    <View
                        className={'card'}
                    >
                        <View
                            className={'card-body'}
                        >
                            <ChocoFormTS
                                lang={AppConfig.lang}
                                form={styleForm}
                                onFormChange={(updatedForm) => {
                                    if (auth.sub) {
                                        if (updatedForm.controls["men_primary_color"].value !== styleForm.controls["men_primary_color"].value) {
                                            updatedForm.controls["men_background_color"].value = LightenColor(updatedForm.controls["men_primary_color"].value, 0.8);
                                        }

                                        if (!needsPreview)
                                            setNeedsPreview(true)
                                    }

                                    updatedForm.edited = true

                                    setStyleForm(updatedForm)
                                    setSaveButtonDisabled(!updatedForm.isValidForm || (cardForm.edited && !cardForm.isValidForm))
                                }}
                            />
                            <View>
                                <h3 style={{marginTop: 50, marginBottom: 15}}>
                                    {TMenuCustomizerScreen[AppConfig.lang].CARD_STYLES}
                                </h3>
                                <ChocoFormTS
                                    lang={AppConfig.lang}
                                    form={cardForm}
                                    onFormChange={(updatedForm) => {
                                        if (auth.sub) {
                                            if (updatedForm.controls["men_card_background_color"].value !== cardForm.controls["men_card_background_color"].value) {
                                                updatedForm.controls["men_card_opacity"].value = 1;
                                            }

                                            if (updatedForm.controls["men_card_opacity"].value == 0) {
                                                updatedForm.controls["men_card_shadow_intensity"].value = 0;
                                            }

                                            if (!needsPreview)
                                                setNeedsPreview(true)
                                        }

                                        updatedForm.edited = true

                                        setCardForm(updatedForm)
                                        setSaveButtonDisabled(!updatedForm.isValidForm || (styleForm.edited && !styleForm.isValidForm))
                                    }}
                                />
                            </View>
                            <View
                                className={'d-flex d-md-none'}
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                {
                                    needsPreview ?
                                        <ThemeButton
                                            disabled={saveButtonDisabled}
                                            text={TMenuCustomizerScreen[AppConfig.lang].PREVIEW}
                                            onPress={() => {
                                                setIsPreviewModalOpen(true)
                                            }}
                                            style={{backgroundColor: Styles.basicBackgroundColor.color}}
                                        />
                                        :
                                        <ThemeButton
                                            disabled={saveButtonDisabled}
                                            text={saving ?
                                                <ActivityIndicator size={20} color={'white'}/>
                                                :
                                                TMenuCustomizerScreen[AppConfig.lang].SAVE}
                                            onPress={editMenu}
                                            style={{backgroundColor: Styles.basicBackgroundColor.color}}
                                        />
                                }
                            </View>
                            <View
                                className={'d-none d-md-flex'}
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <ThemeButton
                                    disabled={saveButtonDisabled}
                                    text={saving ?
                                        <ActivityIndicator size={20} color={'white'}/>
                                        :
                                        TMenuCustomizerScreen[AppConfig.lang].SAVE}
                                    onPress={editMenu}
                                    style={{backgroundColor: Styles.basicBackgroundColor.color}}
                                />
                            </View>
                        </View>
                    </View>
                </View>
                <View className={'col-md-6 d-none d-md-flex'}>
                    <View
                        style={{
                            maxWidth: 375,
                            alignSelf: 'center',
                            borderRadius: 20,
                            border: '3px solid white',
                            overflow: 'hidden',
                            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)'
                        }}
                    >
                        <PreviewWrapper
                            version={'DESKTOP'}
                            menu={menu}
                            styleForm={styleForm}
                            cardForm={cardForm}
                        />
                    </View>
                </View>
            </View>
        </View>
        <View style={{height: 50}}></View>
        {
            auth.sub ?
                <Modal
                    visible={isPreviewModalOpen}
                    onRequestClose={() => setIsPreviewModalOpen(false)}
                    footer={<View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                        {
                            saving ?
                                null
                                :
                                <BorderlessButton
                                    text={TMenuCustomizerScreen[AppConfig.lang].CANCEL}
                                    onPress={() => {
                                        setIsPreviewModalOpen(false)
                                    }}
                                />
                        }
                        <View style={{width: 7}}></View>
                        <ThemeButton
                            disabled={saveButtonDisabled}
                            text={saving ?
                                <ActivityIndicator size={20} color={'white'}/>
                                :
                                TMenuCustomizerScreen[AppConfig.lang].SAVE}
                            onPress={async () => {
                                await editMenu();

                                setNeedsPreview(false)
                                setIsPreviewModalOpen(false)
                            }}
                            style={{backgroundColor: Styles.basicBackgroundColor.color}}
                        />
                    </View>}
                >
                    <View
                        style={{
                            position: 'relative'
                        }}
                    >
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <h1>
                                {TMenuCustomizerScreen[AppConfig.lang].PREVIEW}
                            </h1>
                            <div
                                style={{
                                    textAlign: 'center',
                                    marginBottom: 15
                                }}
                            >
                                {TMenuCustomizerScreen[AppConfig.lang].PREVIEW_DESC}
                            </div>
                            <div
                                style={{
                                    maxWidth: 375
                                }}
                            >
                                <PreviewWrapper
                                    version={'MOBILE'}
                                    menu={menu}
                                    styleForm={styleForm}
                                    cardForm={cardForm}
                                />
                            </div>
                        </View>
                    </View>
                </Modal>
                :
                null
        }
        <View style={{height: 140}}></View>
    </View>;
}

export default MenuCustomizerScreen;

const PreviewWrapper = ({version, menu, styleForm, cardForm}) => {

    return <MenuPreview
        config={{
            logo: menu.meN_LOGO,
            name: menu.meN_NAME,
            primaryColor: styleForm.controls.men_primary_color.value,
            backgroundColor: styleForm.controls.men_background_color.value,
            fontFamily: styleForm.controls.men_font_family.value,
            textAlign: styleForm.controls.men_text_align.value,
            cardBackgroundColor: cardForm.controls.men_card_background_color.value,
            cardBorderWidth: cardForm.controls.men_card_border_width.value,
            cardBorderColor: cardForm.controls.men_card_border_color.value,
            cardBorderRadius: cardForm.controls.men_card_border_radius.value,
            cardOpacity: cardForm.controls.men_card_opacity.value,
            cardShadowIntensity: cardForm.controls.men_card_shadow_intensity.value,
        }}
        currentSection={{
            id: 's-1',
            name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1
        }}
        menuSections={[
            {
                id: 's-1',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1
            },
            {
                id: 's-2',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 2
            },
        ]}
        food={[
            {
                title: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1,
                id: 'f-1',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_FOOD + ' ' + 1,
                prices: [
                    {
                        name: 'DEFAULT',
                        price: 99,
                        currency: 'MXN'
                    }
                ]
            },
            {
                id: 'f-2',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_FOOD + ' ' + 2,
                prices: [
                    {
                        name: 'DEFAULT',
                        price: 50,
                        currency: 'MXN'
                    }
                ],
                description: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_DESCRIPTION
            },
        ]}
    />
}